// extracted by mini-css-extract-plugin
module.exports = {"root":"e_Ly","recognition":"e_My","clue":"e_Ny"};